<template>
  <span :class="className">
    <slot class="blue-17" name="price"></slot>
    <slot></slot>
  </span>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    className: {
      default: 'black-14',
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
.black-16b {
  font-size: 16px;
  font-weight: bold;
  color: #222222;
}
.black-10 {
  font-size: 10px;
  color: #222222;
}
.black-14 {
  font-size: 14px;
  color: #222222;
}
.sec-black-14 {
  font-size: 14px;
  color: #999999;
}

.black-12 {
  font-size: 12px;
  color: #222222;
}
.sec-black-12 {
  font-size: 12px;
  color: #999999;
}
.sec-black-12b {
  font-size: 12px;
  font-weight: bold;
  color: #999999;
}

.sec-black-10 {
  font-size: 10px;
  color: #999999;
}

.blue-14 {
  font-size: 14px;
  color: #41a3ff;
}
.blue-17 {
  font-size: 17px;
  color: #41a3ff;
}
.blue-16b {
  font-size: 16px;
  color: #41a3ff;
  font-weight: bold;
}
.white-14 {
  font-size: 14px;
  color: white;
}
.white-12 {
  font-size: 14px;
  color: white;
}
.white-10 {
  font-size: 14px;
  color: white;
}
.white-16b {
  font-size: 16px;
  color: white;
  font-weight: bold;
}
.blue-12b {
  font-size: 12px;
  color: #41a3ff;
  font-weight: bold;
}
</style>
